import EF from 'ef/ef';
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'lodash';
import { LocalStorageService, MemoryStorageService } from 'services/data-handler-services/web-storage-service';

const ProgressTracker = Backbone.Model.extend({
  initialize: function (attrs, options) {
    this.module = options.module;
    this.key = `progress:${attrs.module_key}`;
    if (EF.options.local) {
      this.storage = LocalStorageService;
    } else {
      this.storage = MemoryStorageService;
    }
  },

  // Saves the progress for the given page or content page. Simple right now... plans to
  // make this smarter with a buffered progress sync
  //
  save: function (page, cb) {
    EF.ContentProvider.ProgressService.saveProgress(this, page, cb);
  },

  savePage: function (contentPage, data, callback) {
    let progress = this.get();
    if (!progress) {
      progress = {};
    }

    progress[data.activity_key] = progress[data.activity_key] || {};
    progress[data.activity_key][data.key] = data;

    if (EF.options.local || EF.enrollment.get('demoMode') === 'preview') {
      this._saveLocal(progress, this._finalizeSave(contentPage, callback));
    } else {
      // filter out injected pages so that we don't save remote progress
      const isCustom =
        contentPage.attributes &&
        Object.prototype.hasOwnProperty.call(contentPage.attributes, 'custom') &&
        contentPage.attributes.custom;

      const trigger = contentPage && Object.prototype.hasOwnProperty.call(contentPage, 'trigger');

      if ((isCustom !== undefined && !isCustom) || trigger) {
        // save page remote and call callback
        this._saveRemote(data, progress, this._finalizeSave(contentPage, callback));
      }

      // save all progress local and don't care about callback
      this._saveLocal(progress);
    }
    // this.recordMostRecentPage(data);
  },

  _finalizeSave: function (page, callback) {
    return function (progress) {
      page.trigger('page:progress:save');
      callback(progress);
    };
  },

  _saveLocal: function (progress, callback) {
    this.storage.setItem(this.key, progress);
    if (callback && typeof callback === 'function') {
      callback(progress);
    }
  },

  _saveRemote: function (pageProgress, progress, callback) {
    const eid = EF.enrollment.get('id');
    const path = EF.ContentProvider.ProgressService.getPath(eid);
    const url = EF.url(path);
    EF.progressQueue.enqueue({
      url: url,
      data: pageProgress,
    });
    EF.trigger('pageProgress:saved', pageProgress);
    callback(progress);
  },

  get: function () {
    return this.storage.getItem(this.key);
  },

  getMostRecentPage: function (callback) {
    const lastPage = this.storage.getItem('last_page');
    if (lastPage) {
      callback(lastPage);
      return;
    }
    callback();
  },

  recordMostRecentPage: function (pageData) {
    this.storage.setItem('last_page', pageData);
  },

  _getLocal: function (callback) {
    const progress = this.storage.getItem(this.key);
    if (progress) {
      callback(progress);
    } else {
      callback();
    }
  },

  _getRemote: function (callback) {
    const eid = EF.enrollment.get('id');
    const url = EF.url(`/sdk/enrollments/${eid}/page_progresses.json`);
    const self = this;
    const params = { module_key: this.module.get('key') };

    let tryCount = 0;
    const makeRequest = function () {
      tryCount++;
      $.ajax({
        dataType: $.support.cors ? 'json' : 'jsonp',
        url: url,
        callback: 'callback',
        data: params,
        success: function (data) {
          if (data) {
            self._saveLocal(data, callback);
          } else {
            self._getLocal(callback);
          }
        },
        error: function () {
          if (tryCount < 3) {
            makeRequest();
          } else {
            //TODO: Make this an alert component
            alert('Unable to load your progress. please try again later');
            // self._getLocal(callback);
          }
        },
      });
    };
    makeRequest();
  },

  load: function (callback) {
    if (EF.options.local) {
      this._getLocal(callback);
    } else {
      this._getRemote(callback);
    }
  },

  forPageAndActivity: function (pageKey, activityKey) {
    const progress = this.get();
    if (!progress) {
      return;
    }
    const actProgress = progress[activityKey];
    if (actProgress) {
      return actProgress[pageKey];
    }
  },

  // Marks an activity complete in the DB.
  markComplete: function () {
    if (!(this.module && this.module.get('key'))) {
      return;
    }
    const moduleKey = this.module.get('key');
    let grade = this.module.get('grade');
    if (typeof grade === 'undefined') {
      grade = 1;
    } //pass/fail

    if (EF.options.local || EF.enrollment.get('demoMode') === 'preview') {
      this.saveLocalActivityProgress({
        attempt: 1,
        enrollment_id: EF.enrollment.get('id'),
        grade: grade,
        passed: grade === 1,
        slug: moduleKey,
        module_key: moduleKey,
      });
    } else {
      EF.ContentProvider.ProgressService.saveActivityProgress(this, grade, 1, moduleKey);
    }
  },

  saveLocalActivityProgress: function (activityProgress) {
    const progress = this.get() || {};
    progress.activity_progresses = progress.activity_progresses || [];
    progress.activity_progresses.push(activityProgress);
    this._saveLocal(progress);
  },

  getLocalActivityProgress: function () {
    const progress = this.get();
    if (progress) {
      return progress.activity_progresses;
    }
  },

  removeLocalActivityProgress: function (slug) {
    const progress = this.get();
    if (progress && progress.activity_progresses) {
      progress.activity_progresses = progress.activity_progresses.filter(ap => ap.slug !== slug);
      this._saveLocal(progress);
    }
  },

  saveActivityProgress: function (grade, attempt, slug) {
    const params = {
      attempt: attempt,
      grade: grade,
      module_key: slug,
    };

    const eid = EF.enrollment.get('id');
    const path = `/sdk/enrollments/${eid}/activity_progresses.json`;
    const url = EF.url(path);

    EF.progressQueue.enqueue({
      url: url,
      data: params,
    });
    this.module.apSaved = true;
    EF.trigger('activityProgress:saved');
  },

  clear: function (callback) {
    if (EF.options.local) {
      this._clearLocal(callback);
    } else {
      this._clearRemote(callback);
    }
  },

  _clearLocal: function (callback) {
    this.storage.removeItem(this.key);
    if (callback) {
      callback(true);
    }
  },

  _clearRemote: function (callback) {
    const eid = EF.enrollment.get('id');
    const path = `/sdk/enrollments/${eid}/page_progresses/${this.module.get('key')}.json`;
    const url = EF.url(path);

    const self = this;
    let tryCount = 0;
    const makeRequest = function () {
      let options = {
        dataType: 'jsonp',
        type: 'GET',
        url: url,
        callback: 'callback',
        success: function () {
          self._clearLocal(callback);
        },
        error: function () {
          if (tryCount < 3) {
            makeRequest();
          } else {
            alert('Unable to clear your progress. please try again later');
            if (callback) {
              callback(false);
            }
          }
        },
      };

      if ($.support.cors) {
        options = _.extend(options, {
          dataType: 'json',
          type: 'DELETE',
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
        });
      } else {
        // If we don't have CORS, set the method override @ _method
        options.data = { _method: 'DELETE' };
      }

      tryCount++;
      $.ajax(options);
    };
    makeRequest();
  },
});

export default ProgressTracker;
